import React from 'react';
import { useParams } from 'react-router-dom';
import PageBlocks from '../components/PageBlocks';
import { isValidLocale } from '../i18n';

/**
 * ResourcesPage — fully migrated to the Block CMS (iter21).
 * Content is editable from the admin visual editor at /admin/pages/resources.
 */
export default function ResourcesPage() {
  const { lang } = useParams();
  const locale = lang && isValidLocale(lang) ? lang : 'es';
  return (
    <div data-testid="resources-page" data-locale={locale}>
      <PageBlocks pageKey="resources" />
    </div>
  );
}
